(function () {
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function clean(value) { return String(value == null ? '' : value).replace(/[\u0000-\u001F\u007F]/g, ' ').trim(); }
  function emit(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    document.dispatchEvent(new CustomEvent('globisun:' + name, { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') window.gtag('event', name, detail || {});
  }
  function init(form) {
    if (form.dataset.gscReady) return;
    form.dataset.gscReady = 'true';
    var params = new URLSearchParams(window.location.search);
    var context = form.dataset.gsCompareContext || 'compare';
    var product = form.querySelector('[data-gsc-product]');
    var quantity = form.querySelector('[data-gsc-quantity]');
    var email = form.querySelector('[data-gsc-email]');
    var body = form.querySelector('[data-gsc-body]');
    var submit = form.querySelector('[data-gsc-submit]');
    var error = form.querySelector('[data-gsc-error]');
    var success = form.querySelector('[data-gsc-success]');
    var fields = form.querySelector('[data-gsc-fields]');
    var started = false;
    keys.forEach(function (key) {
      var field = form.querySelector('[data-gsc-attribution="' + key + '"]');
      if (field) field.value = clean(params.get(key)).slice(0, 500);
    });
    var prefill = clean(params.get('product') || params.get('prefill'));
    if (prefill && product && !product.value) product.value = prefill.slice(0, 2000);
    function start() {
      if (started) return;
      started = true;
      emit('compare_form_start', { placement: context });
    }
    [product, quantity, email].forEach(function (field) { if (field) { field.addEventListener('focus', start, { once: true }); field.addEventListener('input', start, { once: true }); } });
    form.addEventListener('submit', function (event) {
      error.textContent = '';
      if (!form.reportValidity()) { event.preventDefault(); return; }
      keys.forEach(function (key) {
        var attributionField = form.querySelector('[data-gsc-attribution="' + key + '"]');
        if (attributionField) attributionField.value = clean(params.get(key)).slice(0, 500);
      });
      var sourceLines = keys.map(function (key) { var value = clean(params.get(key)); return value ? key + ': ' + value : ''; }).filter(Boolean);
      body.value = [
        'ONE-PRODUCT PRICE COMPARISON',
        'Product: ' + clean(product.value),
        'Approximate quantity: ' + clean(quantity.value),
        'Email: ' + clean(email.value),
        'Entry point: ' + context,
        sourceLines.length ? '\nATTRIBUTION\n' + sourceLines.join('\n') : '',
        '\nNo payment obligation was created. Pricing must be confirmed before payment.'
      ].filter(Boolean).join('\n');
      if (!window.fetch || form.dataset.gscSubmitting === 'true') return;
      event.preventDefault();
      form.dataset.gscSubmitting = 'true';
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text().then(function (html) { return { response: response, html: html }; }); })
        .then(function (result) {
          var confirmed = result.response.ok && (/contact_posted=true/i.test(result.response.url) || /form-status[^>]*success|thanks for contacting us|thanks.{0,20}we received your product/i.test(result.html));
          if (!confirmed) throw new Error('Shopify did not confirm the submission.');
          fields.hidden = true;
          success.hidden = false;
          success.focus && success.focus();
          emit('compare_form_submit', { placement: context, utm_source: clean(params.get('utm_source')), utm_campaign: clean(params.get('utm_campaign')) });
        })
        .catch(function () {
          error.textContent = 'We could not confirm that your request was sent. Please try again or email info@globisun.art.';
          form.dataset.gscSubmitting = 'false';
          submit.disabled = false;
          submit.textContent = 'Compare My Price';
        });
    });
    if (context === 'compare') emit('compare_page_view', { path: window.location.pathname, utm_source: clean(params.get('utm_source')), utm_campaign: clean(params.get('utm_campaign')) });
  }
  function initStart(form) {
    if (form.dataset.gscReady) return;
    form.dataset.gscReady = 'true';
    var product = form.querySelector('[data-gsc-product]');
    var quantity = form.querySelector('[data-gsc-quantity]');
    var error = form.querySelector('[data-gsc-error]');
    var params = new URLSearchParams(window.location.search);
    var prefill = clean(params.get('product') || params.get('prefill'));
    if (prefill && !product.value) product.value = prefill.slice(0, 2000);
    if (params.get('quantity') && !quantity.value) quantity.value = clean(params.get('quantity')).slice(0, 80);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      error.textContent = '';
      if (!form.reportValidity()) return;
      var next = new URL('/compare', window.location.origin);
      next.searchParams.set('view', 'compare');
      next.searchParams.set('product', clean(product.value).slice(0, 2000));
      next.searchParams.set('quantity', clean(quantity.value).slice(0, 80));
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','ref'].forEach(function (key) {
        var value = clean(params.get(key));
        if (value) next.searchParams.set(key, value.slice(0, 500));
      });
      emit('compare_form_start', { placement: 'homepage' });
      window.location.assign(next.pathname + next.search);
    });
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-gs-compare-form]').forEach(init);
    (scope || document).querySelectorAll('[data-gs-compare-start]').forEach(initStart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
